import { all } from 'redux-saga/effects'
import { dashboardSagas } from './dashboard/dashboard.sagas'
import { commonSagas } from './common/common.sagas'
import { helpSagas } from './help/help.sagas'
import { imagesSagas } from './images/images.sagas'

export function * coreRootSaga () {
  yield all([
    dashboardSagas(),
    imagesSagas(),
    commonSagas(),
    helpSagas(),
  ])
}
